module.exports = __webpack_public_path__ + "img/banner3_5.519c6874.png";